import { render, staticRenderFns } from "./providerStore.vue?vue&type=template&id=cfef679c&"
import script from "./providerStore.vue?vue&type=script&lang=babel&"
export * from "./providerStore.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VImg,VMain})
